import { Row } from "react-bootstrap";
import { useWorkspaceStore } from "../../store/WorkspaceStore";
import { Workspace } from "@/backend/models/workspace";
import { I18n } from "@/i18n/I18n";
import { FileSubjectTypes } from "@/types/fileTypes";
import { HierarchyCard } from "./HierarchyCard";
import { useGlobalStore } from "@/frontend/store/GlobalStore";

export function WorkspaceCards(props: { workspaces: Workspace[] }) {
  const { workspaces } = props;

  if(workspaces.length === 0) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100%' }}>
        <h3>{I18n.get('noWorkspaces')}</h3>
      </div>
    );
  }

  return (
    <Row xs={1} md={2} lg={4} className="py-5 g-4">
      {workspaces.map((workspace) => (
        <WorkspaceCard key={workspace.id} workspace={workspace} />
      ))}
    </Row>
  );
}

function WorkspaceCard(props: { workspace: Workspace }) {
  const { workspace } = props;
  const enterprise = useGlobalStore(state => state.enterprise);
  const { deleteWorkspace, updateWorkspace, refetchWorkspace } = useWorkspaceStore();

  return (
    <HierarchyCard
      model={workspace}
      titleLink={`/workspaces/${workspace.id}`}
      modelLabel={I18n.get('workspace')}
      updateModel={updateWorkspace}
      subjectType={FileSubjectTypes.WORKSPACE}
      refetchSubject={refetchWorkspace}
      deleteModel={deleteWorkspace}
      viewOnly={workspace.executorEnterpriseId === enterprise?.id}
    />
  );
}
